// src/flags/waffleFlag.ts
var WaffleFlag = /* @__PURE__ */ ((WaffleFlag2) => {
  WaffleFlag2["AbstractMainnet"] = "abstract-mainnet-allowlist";
  WaffleFlag2["AbstractTestnet"] = "abstract-testnet-allowlist";
  WaffleFlag2["AlchemyarbFam"] = "alchemyarb-fam-allowlist";
  WaffleFlag2["AlchemyarbSepolia"] = "alchemyarb-sepolia-allowlist";
  WaffleFlag2["AlchemyInternal"] = "alchemy-internal";
  WaffleFlag2["AlchemyMainnet"] = "alchemy-mainnet";
  WaffleFlag2["AlchemySepolia"] = "alchemy-sepolia";
  WaffleFlag2["AnimeTestnet"] = "anime-sepolia-allowlist";
  WaffleFlag2["ApeChainCurtis"] = "apechain-curtis-allowlist";
  WaffleFlag2["ApeChainMainnet"] = "apechain-mainnet-allowlist";
  WaffleFlag2["ApexMainnet"] = "apex-mainnet-allowlist";
  WaffleFlag2["ArbNova"] = "arb-nova";
  WaffleFlag2["AvaxFuji"] = "avax-fuji-allowlist";
  WaffleFlag2["AvaxMainnet"] = "avax-mainnet-allowlist";
  WaffleFlag2["BerachainArtio"] = "berachain";
  WaffleFlag2["BerachainBArtio"] = "berachain-bartio-allowlist";
  WaffleFlag2["BerachainMainnet"] = "berachain-mainnet-allowlist";
  WaffleFlag2["Blast"] = "blast";
  WaffleFlag2["BNBMainnet"] = "bnb-mainnet-allowlist";
  WaffleFlag2["BNBTestnet"] = "bnb-testnet-allowlist";
  WaffleFlag2["BOBMainnet"] = "bob-mainnet-allowlist";
  WaffleFlag2["BOBSepolia"] = "bob-sepolia-allowlist";
  WaffleFlag2["BossMainnet"] = "boss-mainnet-allowlist";
  WaffleFlag2["Celo"] = "celo";
  WaffleFlag2["ChilizMainnet"] = "chiliz-mainnet-allowlist";
  WaffleFlag2["ChilizSpicy"] = "chiliz-spicy-allowlist";
  WaffleFlag2["CrossFiMainnet"] = "crossfi-mainnet-allowlist";
  WaffleFlag2["CrossFiTestnet"] = "crossfi-testnet-allowlist";
  WaffleFlag2["DegenMainnet"] = "degen-mainnet-allowlist";
  WaffleFlag2["DegenSepolia"] = "degen-sepolia-allowlist";
  WaffleFlag2["EthHolesky"] = "eth-holesky";
  WaffleFlag2["EthMekong"] = "eth-mekong-allowlist";
  WaffleFlag2["Fantom"] = "fantom";
  WaffleFlag2["FlowMainnet"] = "flow-mainnet-allowlist";
  WaffleFlag2["FlowTestnet"] = "flow-testnet-allowlist";
  WaffleFlag2["GasManagerPredeposit"] = "gas-manager-predeposit";
  WaffleFlag2["GeistMainnet"] = "geist-mainnet-allowlist";
  WaffleFlag2["GeistPolter"] = "geist-polter-allowlist";
  WaffleFlag2["Gnosis"] = "gnosis";
  WaffleFlag2["InkMainnet"] = "ink-mainnet-allowlist";
  WaffleFlag2["InkSepolia"] = "ink-sepolia-allowlist";
  WaffleFlag2["IotaMainnet"] = "iota-mainnet-allowlist";
  WaffleFlag2["IotaTestnet"] = "iota-testnet-allowlist";
  WaffleFlag2["K2Testnet"] = "k2-testnet-allowlist";
  WaffleFlag2["KintoMainnet"] = "kinto-mainnet-allowlist";
  WaffleFlag2["LensSepolia"] = "lens-sepolia-allowlist";
  WaffleFlag2["Linea"] = "linea";
  WaffleFlag2["LumiaPrism"] = "lumia-prism-allowlist";
  WaffleFlag2["LumiaTestnet"] = "lumia-testnet-allowlist";
  WaffleFlag2["MantleMainnet"] = "mantle";
  WaffleFlag2["MantleSepolia"] = "mantle-sepolia";
  WaffleFlag2["MetabasedStratos"] = "metabased-stratos-allowlist";
  WaffleFlag2["MetisMainnet"] = "metis-mainnet-allowlist";
  WaffleFlag2["ModeMainnet"] = "mode-mainnet-allowlist";
  WaffleFlag2["ModeSepolia"] = "mode-sepolia-allowlist";
  WaffleFlag2["MonadTestnet"] = "monad-testnet-allowlist";
  WaffleFlag2["MoonbaseAlpha"] = "moonbase-alpha-allowlist";
  WaffleFlag2["MoonbeamMainnet"] = "moonbeam-mainnet-allowlist";
  WaffleFlag2["MoonriverMainnet"] = "moonriver-mainnet-allowlist";
  WaffleFlag2["OdysseySepolia"] = "odyssey-sepolia-allowlist";
  WaffleFlag2["opBNB"] = "opbnb";
  WaffleFlag2["PalmMainnet"] = "palm-mainnet-allowlist";
  WaffleFlag2["PalmTestnet"] = "palm-testnet-allowlist";
  WaffleFlag2["Pipelines"] = "allow_data_platform";
  WaffleFlag2["PlumeTestnet"] = "plume-testnet-allowlist";
  WaffleFlag2["PolynomialMainnet"] = "polynomial-mainnet-allowlist";
  WaffleFlag2["PolynomialSepolia"] = "polynomial-sepolia-allowlist";
  WaffleFlag2["RaasDashboard"] = "enable_raas_dashboard";
  WaffleFlag2["RaasSelfServe"] = "enable_raas_self_serve";
  WaffleFlag2["RaceMainnet"] = "race-mainnet-allowlist";
  WaffleFlag2["RaceTestnet"] = "race-sepolia-allowlist";
  WaffleFlag2["RootstockMainnet"] = "rootstock-mainnet-allowlist";
  WaffleFlag2["RootstockTestnet"] = "rootstock-testnet-allowlist";
  WaffleFlag2["RoninMainnet"] = "ronin-mainnet-allowlist";
  WaffleFlag2["RoninSaigon"] = "ronin-saigon-allowlist";
  WaffleFlag2["Scroll"] = "scroll";
  WaffleFlag2["SeiMainnet"] = "sei-mainnet-allowlist";
  WaffleFlag2["SeiTestnet"] = "sei-testnet-allowlist";
  WaffleFlag2["SettlusMainnet"] = "settlus-mainnet-allowlist";
  WaffleFlag2["SettlusSeptestnet"] = "settlus-septestnet-allowlist";
  WaffleFlag2["ShapeMainnet"] = "shape-mainnet-allowlist";
  WaffleFlag2["ShapeSepolia"] = "shape-sepolia-allowlist";
  WaffleFlag2["ShidenMainnet"] = "shiden-mainnet-allowlist";
  WaffleFlag2["ShidenShibuya"] = "shiden-shibuya-allowlist";
  WaffleFlag2["SignerService"] = "signer-service";
  WaffleFlag2["SocialLoginForAccounts"] = "enable_social_login_for_accounts";
  WaffleFlag2["SocialNetworkMainnet"] = "socialnetwork-mainnet-allowlist";
  WaffleFlag2["SocialNetworkTestnet"] = "socialnetwork-testnet-allowlist";
  WaffleFlag2["SoneiumMainnet"] = "soneium-mainnet-allowlist";
  WaffleFlag2["SoneiumMinato"] = "soneium-minato-allowlist";
  WaffleFlag2["SonicBlaze"] = "sonic-blaze-allowlist";
  WaffleFlag2["SonicMainnet"] = "sonic-mainnet-allowlist";
  WaffleFlag2["SonicTestnet"] = "sonic-testnet-allowlist";
  WaffleFlag2["SpotlightMainnet"] = "spotlight-mainnet-allowlist";
  WaffleFlag2["SpotlightSepolia"] = "spotlight-sepolia-allowlist";
  WaffleFlag2["StandardMainnet"] = "standard-mainnet-allowlist";
  WaffleFlag2["StandardTestnet"] = "standard-testnet-allowlist";
  WaffleFlag2["SuperseedMainnet"] = "superseed-mainnet-allowlist";
  WaffleFlag2["SuperseedSepolia"] = "superseed-sepolia-allowlist";
  WaffleFlag2["SyndicateExo"] = "syndicate-exo-allowlist";
  WaffleFlag2["UnichainMainnet"] = "unichain-mainnet-allowlist";
  WaffleFlag2["UnichainSepolia"] = "unichain-sepolia-allowlist";
  WaffleFlag2["UniteMainnet"] = "unite-mainnet-allowlist";
  WaffleFlag2["UniteTestnet"] = "unite-testnet-allowlist";
  WaffleFlag2["UsageLimitBanner"] = "usage_limit_banner";
  WaffleFlag2["UsageLimitBannerHoverState"] = "usage_limit_banner_hover_state";
  WaffleFlag2["WorldChainMainnet"] = "worldchain-mainnet";
  WaffleFlag2["WorldChainSepolia"] = "worldchain-sepolia";
  WaffleFlag2["XMTPTestnet"] = "xmtp-testnet-allowlist";
  WaffleFlag2["ZetaChain"] = "zetachain";
  WaffleFlag2["ZKsync"] = "zksync";
  return WaffleFlag2;
})(WaffleFlag || {});

export {
  WaffleFlag
};
//# sourceMappingURL=chunk-HSBWRRCY.mjs.map